export default __webpack_public_path__ + "static/media/person_finish.0ad6bfb3.svg";